import React from "react";

const studentAdd = () => {
  return (
    <div className="dashboard-body">
        <div className="card mt-24">
        <div className="card-header border-bottom">
            <h4 className="mb-4">My Details</h4>
            <p className="text-gray-600 text-15">
            Please fill full details about yourself
            </p>
        </div>
        <div className="card-body">
            <form action="#">
            <div className="row gy-4">
                <div className="col-sm-6 col-xs-6">
                <label htmlFor="fname" className="form-label mb-8 h6">
                    First Name
                </label>
                <input
                    type="text"
                    className="form-control py-11"
                    id="fname"
                    placeholder="Enter First Name"
                />
                </div>
                <div className="col-sm-6 col-xs-6">
                <label htmlFor="lname" className="form-label mb-8 h6">
                    Last Name
                </label>
                <input
                    type="text"
                    className="form-control py-11"
                    id="lname"
                    placeholder="Enter Last Name"
                />
                </div>
                <div className="col-sm-6 col-xs-6">
                <label htmlFor="email" className="form-label mb-8 h6">
                    Email
                </label>
                <input
                    type="email"
                    className="form-control py-11"
                    id="email"
                    placeholder="Enter Email"
                />
                </div>
                <div className="col-sm-6 col-xs-6">
                <label htmlFor="phone" className="form-label mb-8 h6">
                    Phone Number
                </label>
                <input
                    type="number"
                    className="form-control py-11"
                    id="phone"
                    placeholder="Enter Phone Number"
                />
                </div>
                <div className="col-12">
                <label htmlFor="imageUpload" className="form-label mb-8 h6">
                    Your Photo
                </label>
                <div className="flex-align gap-22">
                    <div className="avatar-upload flex-shrink-0">
                    <input
                        type="file"
                        id="imageUpload"
                        accept=".png, .jpg, .jpeg"
                    />
                    <div className="avatar-preview">
                        <div
                        id="profileImagePreview"
                        style={{
                            backgroundImage:
                            "url('assets/images/thumbs/setting-profile-img.jpg')",
                        }}
                        ></div>
                    </div>
                    </div>
                    <div className="avatar-upload-box text-center position-relative flex-grow-1 py-24 px-4 rounded-16 border border-main-300 border-dashed bg-main-50 hover-bg-main-100 hover-border-main-400 transition-2 cursor-pointer">
                    <label
                        htmlFor="imageUpload"
                        className="position-absolute inset-block-start-0 inset-inline-start-0 w-100 h-100 rounded-16 cursor-pointer z-1"
                    ></label>
                    <span className="text-32 icon text-main-600 d-inline-flex">
                        <i className="ph ph-upload"></i>
                    </span>
                    <span className="text-13 d-block text-gray-400 text my-8">
                        Click to upload or drag and drop
                    </span>
                    <span className="text-13 d-block text-main-600">
                        SVG, PNG, JPEG OR GIF (max 1080px1200px)
                    </span>
                    </div>
                </div>
                </div>
                <div className="col-sm-6 col-xs-6">
                <label htmlFor="role" className="form-label mb-8 h6">
                    Role
                </label>
                <input
                    type="text"
                    className="form-control py-11"
                    id="role"
                    placeholder="Enter Role"
                />
                </div>
                <div className="col-sm-6 col-xs-6">
                <label htmlFor="zip" className="form-label mb-8 h6">
                    ZIP Code
                </label>
                <input
                    type="number"
                    className="form-control py-11"
                    id="zip"
                    placeholder="Enter ZIP Code"
                />
                </div>
                <div className="col-12">
                <div className="editor">
                    <label className="form-label mb-8 h6">Bio</label>
                    <div id="editor">
                    <p>
                        I'm a Product Designer based in Melbourne, Australia. I
                        specialise in UX/UI design, brand strategy, and Webflow
                        development. It has survived not only five centuries, but
                        also the leap into electronic typesetting, remaining
                        essentially unchanged.
                    </p>
                    </div>
                </div>
                </div>
                <div className="col-12">
                <div className="flex-align justify-content-end gap-8">
                    <button
                    type="reset"
                    className="btn btn-outline-main bg-main-100 border-main-100 text-main-600 rounded-pill py-9"
                    >
                    Cancel
                    </button>
                    <button
                    type="submit"
                    className="btn btn-main rounded-pill py-9"
                    >
                    Save Changes
                    </button>
                </div>
                </div>
            </div>
            </form>
        </div>
        </div>
    </div>
  );
};

export default studentAdd;
